'use client';

import { LayoutWithCarousel } from '@/components/Layout';
import Spacing from '@/components/container/Spacing';
import { TextBodyMedium, TextHeadlineLarge } from '@/components/text/Texts';
import LoadingDialog from '@/components/utils/LoadingDialog';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import '../authentication-screens.styles.css';
import CreatePasswordSuccess from './components/CreatePasswordSuccess';
import { useForm, useWatch } from 'react-hook-form';
import Container from '@/components/container/Container';
import PasswordInput from '@/components/form-inputs/PasswordInput';
import { CREATE_PASSWORD_FORM } from '@/constants/forms';
import { RoundedFilledButton } from '@/components/buttons/Buttons';
import { axiosInstance } from '@/services/axios.service';
import { BaseResponse } from '@/types';
import { ENDPOINTS } from '@/constants/endpoints';
import { useSearchParams } from 'react-router-dom';
import { isValid } from 'date-fns';

export interface SendPasswordResetRequest {
	Email: string;
	Token: string;
	NewPassword: string;
}
interface ResetPasswordForm {
	NewPassword: string;
	ConfirmNewPassword: string;
}

const ResetPasswordScreen = () => {
	const [searchParams] = useSearchParams();
	const [isLoading, setIsLoading] = useState(false);
	const [showSuccessScreen, setShowSuccessScreen] = useState(false);

	const form = useForm<ResetPasswordForm>({
		mode: 'all'
	});


	const handleClick = async () => {
		const token = searchParams.get('token');
		const email = searchParams.get('email');
		setIsLoading(true);
		try {
			const response = await axiosInstance.post<BaseResponse>(ENDPOINTS['/api/X4bUser/ResetPassword'], { Email: email, Token: token, NewPassword: form.getValues().ConfirmNewPassword } as SendPasswordResetRequest);
			if (response.data.Success) {
				setShowSuccessScreen(!showSuccessScreen);
			}

		} finally {
			setIsLoading(false);
		}
	};
	return (
		<>
			<LoadingDialog isLoading={isLoading} />
			<Dialog
				header=""
				visible={showSuccessScreen}
				className="custom-dialog-modal"
				closable={false}
				maximized={true}
				onHide={() => {
					if (!showSuccessScreen) return;
					setShowSuccessScreen(false);
				}}
				pt={{
					content: () => ({
						className: 'dialog-content-reset',
					}),
				}}
			>
				<CreatePasswordSuccess
					setShowSuccessScreen={setShowSuccessScreen}
					showSuccessScreen={showSuccessScreen}
				/>
			</Dialog>
			<LayoutWithCarousel>
				<Card className="login-screen">
					<TextHeadlineLarge
						text="Create new password"
						className="text-inverseSurface"
					/>
					<Spacing height="h-1" />
					<TextBodyMedium
						text="Please create new password for your account."
						className="text-formTextGray"
					/>

					<Spacing height="h-8" />

					{/* <CreatePasswordForm onClick={handleClick} /> */}
					<Container className="flex flex-col w-full p-input-filled">
						<PasswordInput
							className="password-form-input w-full"
							control={form.control}
							formName={CREATE_PASSWORD_FORM}
							feedback={true}
							id="NewPassword"
							label="New Password"
							placeholder="Enter new password"
						/>

						<Spacing height="h-4" />

						<PasswordInput
							className="password-form-input"
							control={form.control}
							formName={CREATE_PASSWORD_FORM}
							id="ConfirmNewPassword"
							label="Confirm Password"
							placeholder=""
							needValidIcon
							rules={{
								required: 'Confirm password is required',
								validate: (value: string) => value === form.getValues().NewPassword || 'Password does not match'
							}}
						/>

						<Spacing height="h-9" />

						<RoundedFilledButton
							id="update-button"
							className={
								form.formState.isValid
									? 'login-button'
									: 'login-button isDisabled'
							}
							label="Update Password"
							disabled={!form.formState.isValid}
							onClick={handleClick}
						/>
					</Container>
				</Card>
			</LayoutWithCarousel>
		</>
	);
};

export default ResetPasswordScreen;
